import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "menu" }

import { filesOrNull } from "@/controllers/_tech";
import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent, JSONContent } from '@tiptap/vue-3'
import { onBeforeMount, onMounted, onUnmounted, reactive, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue', 'submit', 'files'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

function focus(){

  

  model.editor?.chain().focus().run()

  
}

const props = __props

const emit = __emit


const model: { editor: Editor | undefined } = reactive({ editor: undefined })

function onDrop(e: DragEvent) {

  const f = filesOrNull(e)

  if (f!=null) emit('files', f)

}

function onPaste(event: ClipboardEvent) {

  const files = event?.clipboardData?.files ?? null;

  if (files != null) emit('files', [...files])

  console.log('paste file at editor')

}

onMounted(() => {

  model.editor = new Editor({
    extensions: [
      StarterKit,
    ],
    content: props.modelValue,
    onUpdate: () => {
      // HTML
      //this.$emit('update:modelValue', model.editor!.getHTML())

      // JSON
      emit('update:modelValue', model.editor!.getHTML())
    },
    editorProps: {
      handleDOMEvents: {
        keydown: (view, event) => {

          if (event.key === "Enter" && !event.ctrlKey) {

            emit('submit', model.editor!.getHTML())

            event.preventDefault();

            return true;
          }

          return false;
        }
      },
    }
  })

})

onUnmounted(() => {

  model.editor?.destroy()

  model.editor = undefined;

})

watch(() => props.modelValue, (value) => {

  // HTML
  const isSame = model.editor!.getHTML() === value

  // JSON
  // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

  if (isSame) {
    return
  }

  model.editor!.commands.setContent(value, false)

})

function json() {

  return model!.editor!.getJSON()
}

function set(value: string) {

  model?.editor?.commands.setContent(value, false)
}

function clear() {

  model?.editor?.commands.clearContent(false);
  model?.editor?.chain().focus(0)
}

__expose({ json, set, clear, focus })


return (_ctx: any,_cache: any) => {
  const _component_dev_button = _resolveComponent("dev-button")!

  return (model.editor)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_dev_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (model.editor!.chain().focus().toggleBold().run())),
            disabled: !model.editor.can().chain().focus().toggleBold().run(),
            class: _normalizeClass({ 'is-active': model.editor.isActive('bold') })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Bold ")
            ]),
            _: 1
          }, 8, ["disabled", "class"]),
          _createTextVNode(" Hotkey: Ctrl+\\ to focus ")
        ]),
        _createVNode(_unref(EditorContent), {
          class: "content",
          editor: model.editor,
          onDrop: _withModifiers(onDrop, ["prevent"]),
          onPaste: onPaste
        }, null, 8, ["editor"])
      ]))
    : _createCommentVNode("", true)
}
}

})